module.exports = __webpack_public_path__ + "static/CV-7ea12290b36bf80497b5ba6b61092715.pdf";